import type { GenomicFeatureTypeEnum } from "@selector/shared/openapi";
import { type components, type SyntenyTypeEnum } from "@selector/shared/openapi";

import {
  fetchFamilyMembersCondensedOrThrow,
  fetchPangenomeAlignmentMembersByFeatureOrThrow,
  fetchPangenomeAlignmentMembersOrThrow,
  type SyntenyFamilyContigs,
} from "../../../api/fetch.ts";

export type GenomeMember = components["schemas"]["SyntenyFamilyMemberResponse"] & {
  contigId: number;
  contigName: string;
  organismId: number;
  organismName: string;
  familyId?: number;
};

export const toMembersByGenome = (familyMembers: SyntenyFamilyContigs, familyId?:number) => {
  const membersByGenome = new Map<number, GenomeMember[]>();
  for (const genome of familyMembers) {
    const genomeMembers: GenomeMember[] = [];
    for (const contig of genome.contigs) {
      const contigMembers = contig.members.map((member) => ({
        ...member,
        contigId: contig.contigId,
        contigName: contig.contigName,
        organismId: genome.organismId,
        organismName: genome.organismName,
        familyId,
      }));
      genomeMembers.push(...contigMembers);
    }
    if (genomeMembers.length > 0) {
      membersByGenome.set(genome.organismId, genomeMembers);
    }
  }
  return membersByGenome;
}

export async function getSequenceFamilyMembersByGenomeOrThrow(
  syntenyId: number,
  familyId: number,
): Promise<Map<number, GenomeMember[]>> {
  return toMembersByGenome(await fetchPangenomeAlignmentMembersOrThrow(syntenyId, familyId), familyId);
}

export const getAlignmentMembersByGenomeOrThrow = async (
  syntenyOrgId: number,
  featureType: GenomicFeatureTypeEnum,
  featureId: number,
) => {
  return toMembersByGenome(await fetchPangenomeAlignmentMembersByFeatureOrThrow(syntenyOrgId, featureType, featureId));
};

export async function getFeaturesFamilyMembersByGenomeOrThrow(
  familyId: number,
  syntenyOrgId: number,
  syntenyType: SyntenyTypeEnum,
  featureId: number,
): Promise<Map<number, GenomeMember[]>> {
  return toMembersByGenome(await fetchFamilyMembersCondensedOrThrow(syntenyOrgId, syntenyType, featureId), familyId);
}
